module.exports = __webpack_public_path__ + "static/media/image6.a113ed7d.jpg";